import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

const Testimonial: React.FC = () => {
  const { t } = useLocale()

  return (
    <section className="mx-auto max-w-[880px] px-5 py-16 text-center sm:px-8 lg:px-14 lg:py-[88px]">
      <blockquote className="text-balance font-display text-[22px] font-semibold leading-snug sm:text-[28px]">
        &ldquo;{t('testimonial.quote')}&rdquo;
      </blockquote>
      <figcaption className="mt-6 flex items-center justify-center gap-3">
        <span
          aria-hidden
          className="inline-flex h-11 w-11 items-center justify-center rounded-full text-[15px] font-bold text-white"
          style={{ background: '#2B6E8C' }}
        >
          EV
        </span>
        <span className="text-left">
          <span className="block text-[15px] font-semibold">{t('testimonial.name')}</span>
          <span className="block text-[13px] text-text-muted">{t('testimonial.role')}</span>
        </span>
      </figcaption>
    </section>
  )
}

export default Testimonial
